<template>
    <div class="flex flex-col overflow-x-auto">
        <div class="inline-block min-w-full py-2">
            <div class="overflow-x-auto">
                <div class="min-w-full text-left text-sm font-light">
                    <div class="border-b font-medium dark:border-neutral-500">
                        <div class="flex justify-between">
                            <div v-for="(header, index) in titleHeaders" :key="index" class="px-6 py-2 text-gray-400 w-12 lg:w-16 flex-grow">{{ header }}</div>
                        </div>
                    </div>
                    <div>
                        <div v-for="(item, index) in rows" :key="index" class="border-b border-dashed dark:border-neutral-500 w-full flex justify-start animate-pulse">
                            <div class="w-full flex justify-between">
                                <div v-for="(header, index) in titleHeaders" :key="index" class="px-6 py-2 text-gray-400 w-12 lg:w-16 flex-grow">
                                    <div class="h-4 w-24 lg:w-40 bg-gray-300 animate-pulse"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "table-shimmer",
    props: ["titleHeaders", "rows",],
}
</script>